module.exports = __webpack_public_path__ + "img/search-left.d2e903c1.png";